
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exam/[exam_name]",
      function () {
        return require("private-next-pages/exam/[exam_name]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exam/[exam_name]"])
      });
    }
  